import { render, staticRenderFns } from "./FeedLikers.vue?vue&type=template&id=ae5644a6&scoped=true&"
import script from "./FeedLikers.vue?vue&type=script&lang=ts&"
export * from "./FeedLikers.vue?vue&type=script&lang=ts&"
import style0 from "./FeedLikers.vue?vue&type=style&index=0&id=ae5644a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5644a6",
  null
  
)

export default component.exports